/* eslint consumerweb/no-indexof: 0 */
/**
 * Transaction Model
 * @author Tyler Stark, tbroussard
 *
 * Important Notes:
 *  By not specifying a url, the url path is delegated down from the transactionCollection
 *  idAttribute auto sets the id attribute: this.collection.get('some-id')
 */

import Backbone from 'backbone';

let Transaction = Backbone.Model.extend({

	defaults: {
		amounts: {
			balance: 0,
			balanceCurrencyCode: '',
			gross: 0,
			grossCurrencyCode: '',
			net: 0,
			fee: 0
		},
		status: 'COMPLETED',
		detailsLink: '',
		isLoading: false,	// Does the Transaction item need a spinner
		isExpanded: false,	// Does the Transaction item need the blue left border
		isAppended: false 	// Has the view been appended to an element in the UI
	},

	/**
	 * Determine if Inline Transaction Details feature is enabled
	 */
	isInlineEnabled: function () {
		let detailsLink = this.get('detailsLink'),
			isSmartphone = this.get('wurfl') && this.get('wurfl').isSmartphone,
			isInlineEnabled = (detailsLink.indexOf('webscr') < 0) && !isSmartphone;

		if (!isInlineEnabled) {
			if (detailsLink.indexOf('id=INV2-') > -1) {
				Backbone.trigger('trackLink', null, 'td_open', 'main:walletweb:activity:invoice:td_open:', null, 'link');
			}
		}

		return isInlineEnabled;
	},


	/**
	 * Use to toggle boolean properties
	 * @param key Property key
	 * @param value Boolean property value
	 */
	toggleProp: function (key, value) {
		if (typeof value === 'undefined') {
			value = !this.get(key);
		}
		this.set(key, value);
	},

	urlRoot: function () {
		if (this.get('transactionType') === 'moneyRequest') {
			return Backbone.history.options.root + 'transaction/money-requests/' + this.get('groupRequestId') + '/details';
		} else if (this.get('transactionType') === 'order') {
			return Backbone.history.options.root + 'transaction/orders';
		}

		return Backbone.history.options.root + 'transaction/details';
	}

});

export default Transaction;



// WEBPACK FOOTER //
// ./model/activity/transactionModel.es6